import React, { memo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import { cn } from 'src/lib/cn';

import Loader from '../shared/loader';
import Fallback from '../shared/fallback';
import LocationCell from './location';
import TaskModal from './task-modal';

type Props = {
    zones: Record<string, any>[];
    loading: boolean;
    locationDensity?: number
    activeParcel:string
}
export const WorkerTaskingLive: React.FC<Props> = memo(({
    zones,
    loading,
    locationDensity,
    activeParcel
}) => {
    const navigate = useNavigate();
    const params = useParams();
    const [worker, setWorker] = useState<LocationType>();
    const [open, setOpen] = useState(false);
    const [, setShowModal] = useState(false);
    const hasTwoColumns = zones?.some(z => z.widget_zone_column === 2);
    console.log({ locationDensity });

    const onSelectTask = (location: LocationType) => {
        if(location?.worker_plans?.length > 0){
            setWorker(location);
            setOpen(true);
        }else{
            setShowModal(true)
        }     
    };

    const columnOneZones = zones?.filter(data => data.widget_zone_column === 1) || [];
    const otherZones = zones?.filter(data => data.widget_zone_column !== 1) || [];
    const sortedZones = [...columnOneZones, ...otherZones];

    return (
        <div className='no-scrollbar flex flex-col'>
            {loading ? <Loader /> :
                <div className='flex flex-col w-full mt-4 gap-1'>
                    {zones?.length > 0 ? sortedZones.map((data, idx) => {
                        return (
                            <div key={idx} className={cn(
                                `grid-cols-${data.widget_zone_column} grid-row-${data.widget_zone_row} border-gray-400`,
                                {
                                    'last-of-type: border-b-0': data?.widget_zone_column !== 1 && hasTwoColumns,
                                    'last-of-type: border-b-2': data?.widget_zone_column === 1 && hasTwoColumns,
                                    'pb-1': data?.widget_zone_column === 1,
                                    'pb-0': data?.widget_zone_column !== 1,
                                }
                            )}>
                                <div className='flex gap-2'>
                                    <div className={cn(`grid gap-0.5 items-center min-h-0 border border-gray-200 grid-cols-7`)}>
                                        {data?.locations_aggregate?.nodes?.map((location: LocationType, i: number) => (
                                            <LocationCell
                                                key={i}
                                                onSelectTask={onSelectTask}
                                                workerId={params?.workerId}
                                                location={location}
                                            />
                                        ))}
                                    </div>
                                    <p className={`text-xs w-4 text-center
                                     ${data?.widget_zone_column === 1 ? 'order-1' : '-order-1'}`} >
                                        {data?.zone_moniker}
                                    </p>
                                </div>
                            </div>
                        )
                    }) : <Fallback
                        title={!activeParcel ? 'No parcel has been selected' : 'No active task running'}
                        actionBtnLabel='Select Parcel'
                        {...(!activeParcel && { onAction: () => navigate('/settings') })}
                    />}
                </div>
            }

            <TaskModal open={open} data={worker} setOpen={setOpen} />
        </div>
    );
});